import { all, fork } from 'redux-saga/effects';
import currencyUploadSaga from '../saga/currency/currencyUploadSaga';
import itemsNBundleUploadSaga from '../saga/itemsNbundles/itemsNBundleUploadSaga';
import storeFileUploadSaga from '../saga/stores/storeFileUploadSaga';

export default function* rootSaga() {
  yield all([fork(currencyUploadSaga), fork(itemsNBundleUploadSaga), fork(storeFileUploadSaga)]);
}
